import type { ReactNode } from "react"
import style from "./FooterBar.module.scss"

const { footer, topSlot: topSlotCls, actions } = style

type Props = {
	topSlot?: ReactNode
	children: ReactNode
	className?: string
}

export const FooterBar = ({ topSlot, children, className = "" }: Props) => {
	return (
		<div className={`${footer} ${className}`}>
			{topSlot ? <div className={topSlotCls}>{topSlot}</div> : null}
			<div className={actions}>{children}</div>
		</div>
	)
}
